import {
  LogOut,
  LucideProps,
  
  User2Icon,
} from 'lucide-react'
import { ExoticComponent } from 'react'

type afterNavElementsProps = "account" | "logout"

export const navIconMap: Partial<
  Record<afterNavElementsProps, ExoticComponent<LucideProps>>
> = {
  account: User2Icon,
  logout: LogOut
}

export const getNavIcon = (slug: string) =>
  Object.hasOwn(navIconMap, slug) ? navIconMap[slug as afterNavElementsProps] : undefined
